import { render, staticRenderFns } from "./WorkersCompBlock.vue?vue&type=template&id=faae65da&scoped=true"
import script from "./WorkersCompBlock.vue?vue&type=script&lang=js"
export * from "./WorkersCompBlock.vue?vue&type=script&lang=js"
import style0 from "./WorkersCompBlock.vue?vue&type=style&index=0&id=faae65da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faae65da",
  null
  
)

export default component.exports